import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { gql, ResultOf } from '@/utilities/gql';

const QUERY = gql(`
  query getPortfolioDividendAnalysis($portfolioId: String!) {
    Portfolio(id: $portfolioId) {
      id
      currencyISO
      isAnalysisRestricted
      analysis {
        estimatedDividendYield
        estimatedYearlyDividendFuture1y
        estimatedYearlyDividendYieldOnCapitalInvested
        estimatedYearlyDividendPast1y
      }
      holdingsCount
    }
  }
`);

export const usePortfolioDividend = makeGqlSuspenseQuery(QUERY, {
  staleTime: 1000 * 60 * 60,
});

export type PortfolioDividendDataRaw = ResultOf<typeof QUERY>;

export type PortfolioDividendData = PortfolioDividendDataRaw['Portfolio'];
